// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","682":"component---src-pages-about-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"1fff06ad3fea824c153a","682":"5bf2f9440a86e9596516","883":"2f2958f47f2a496e7962"}[chunkId] + ".js";
};